import React from 'react'

const PAIR_COUNT = 6
const barHeights = [80, 160, 60, 100, 90, 130]

const GenderBarChartSkeleton = ({ height = 250 }) => (
    <div className="w-full mt-[20px] relative pl-[90px]">
        <div className="absolute left-0 bottom-[50px] rotate-180 items-center text-[#d1d0e1] select-none" style={{ writingMode: 'vertical-rl' }}>
            <div className="flex flex-col items-center">
                <div className="h-[180px] w-4 bg-lightBG rounded opacity-50"></div>
                <div className="h-[120px] w-4 bg-lightBG rounded opacity-50 mr-2"></div>
            </div>
        </div>
        <div className="w-full bg-lightBG animate-pulse flex gap-[56px] items-end px-[56px]" style={{ height }}>
            {Array.from({ length: PAIR_COUNT }).map((_, idx) => (
                <div key={idx} className="flex flex-row gap-[8px] items-end" style={{ marginRight: idx < PAIR_COUNT - 1 ? 60 : 0 }}>
                    {/* Boys bar */}
                    <div
                        className="rounded-t-[6px]"
                        style={{
                            width: 25,
                            height: 120 + (idx % 3) * 18,
                            background: '#fbcfe8',
                            opacity: 0.7,
                        }}
                    />
                    {/* Girls bar */}
                    <div
                        className="rounded-t-[6px]"
                        style={{
                            width: 25,
                            height: 140 + (idx % 2) * 12,
                            background: '#fbcfe8',
                            opacity: 0.7,
                        }}
                    />
                </div>
            ))}
        </div>
        <div className="flex flex-row justify-between items-center px-16 mt-2 w-full z-20">
            {barHeights.map((_, i) => (
                <div className="flex flex-col items-center gap-2">
                    <div key={i} className="h-2 w-10 bg-lightPurpleGray rounded-full opacity-60"></div>
                    <div className="h-8 w-8 bg-lightPurpleGray rounded-full opacity-60"></div>
                </div>
            ))}
        </div>
    </div>
)

export default GenderBarChartSkeleton
